import { useMemo } from 'react';
import { filterWorkspaces } from '../../queues/helpers/filterWorkspaces';
import { WorkspaceWithQueues } from '../../queues/hooks/useWorkspacesWithQueues';
import { QueueManagerFilters } from './useQueueManagerFilterSettings';

type UseFilteredWorkspacesProps = {
  workspaces: WorkspaceWithQueues[];
  searchValue: string;
  filters: QueueManagerFilters;
};

export const hasAnyActiveFilter = (filters: QueueManagerFilters): boolean =>
  Object.values(filters).some(
    value => value !== undefined && (!Array.isArray(value) || value.length > 0)
  );

export const useFilteredWorkspaces = ({
  workspaces,
  searchValue,
  filters,
}: UseFilteredWorkspacesProps): WorkspaceWithQueues[] =>
  useMemo(() => {
    const searchFiltered = searchValue
      ? filterWorkspaces(searchValue, workspaces)
      : workspaces;

    const hasActiveFilters = hasAnyActiveFilter(filters);

    return hasActiveFilters
      ? searchFiltered.filter(ws => ws.queues.length > 0)
      : searchFiltered;
  }, [workspaces, searchValue, filters]);
